import { useFeatureFlagVariantKey } from "posthog-js/react";

export const FREE_UPLOAD_LIMIT_FLAG = "free-upload-limit";
export const DEFAULT_FREE_UPLOAD_LIMIT = 2;
export const TEST_FREE_UPLOAD_LIMIT = 5;

export const useFreeUploadLimit = () => {
  const variant = useFeatureFlagVariantKey(FREE_UPLOAD_LIMIT_FLAG);
  return variant === "test"
    ? TEST_FREE_UPLOAD_LIMIT
    : DEFAULT_FREE_UPLOAD_LIMIT;
};
